import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';

import { ProgressBarComponent } from './progress-bar.component';

@NgModule({
    imports: [CommonModule, ProgressbarModule.forRoot()],
    exports: [ProgressBarComponent],
    declarations: [ProgressBarComponent]
})
export class ProgressBarModule {}
